import { useMemo } from 'react';
import apiClient from 'src/api/axiosClient';
import { Company } from 'src/constants/types';
import {
  AdminCompany,
  CreateAdminCompanyRequestData,
  GetAdminCompaniesParams,
  GetStripeCompanyPortalLinkParams,
  OnboardingCompanyStatus,
} from '../types';

export function useCompaniesApi() {
  return useMemo(
    () => ({
      getUserCompanies: () => {
        return apiClient.get<Company[]>(`/users/companies`);
      },

      getAdminCompanies: (params: GetAdminCompaniesParams) => {
        return apiClient.get<{ items: AdminCompany[]; count: number }>(`/companies`, { params });
      },

      createAdminCompany: (data: CreateAdminCompanyRequestData) => {
        return apiClient.post<AdminCompany>(`/companies`, data);
      },

      deleteAdminCompany: (companyId: string) => {
        return apiClient.delete<void>(`companies/${companyId}`);
      },

      getCompanyPaymentMethod: async (companyId: string) => {
        const response = await apiClient.get<AdminCompany>(`/companies/${companyId}/payment-method`);
        return response.data.hasPaymentMethod;
      },

      getStripeCompanyPortalLink: (
        companyId: string,
        params?: GetStripeCompanyPortalLinkParams,
      ) => {
        return apiClient.get<{ url: string }>(`companies/${companyId}/stripe-portal`, { params });
      },
      
      completeOnboarding: (companyId: string) => {
        return apiClient.post<void>(`/companies/${companyId}/complete-onboarding`);
      },

      getOnboardingStatus: (companyId: string) => {
        return apiClient.get<OnboardingCompanyStatus>(`/companies/${companyId}/onboarding-status`);
      },
    }),
    [],
  );
}
